import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import './TopicDeleteConfirmationDialog.styl';

/**
 * Dialog prompting the user to confirm or cancel topic delete.
 */
export default class TopicDeleteConfirmationDialog extends React.PureComponent {
  static propTypes = {
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
  };

  render() {
    const {message, onClose, onConfirm, open} = this.props;
    const title = 'Delete Topic?';
    return (
      <Dialog
        open={open}
        onRequestClose={onClose}
        title={title}
        modal
        autoScrollBodyContent={false}
        closeButton={false}
        contentClassName="topic-delete-confirmation-dialog-content"
        className="topic-delete-confirmation-dialog">
        <div>
          <div className="topic-delete-confirmation-dialog-message">{message}</div>
          <div className="topic-delete-confirmation-dialog-buttons">
            <Button
              variant="outlined"
              onClick={onClose}
              labelStyle={{color: 'white', textTransform: 'none'}}
              className="no-button ev-button">
              No - Do Not Delete
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onConfirm}
              labelStyle={{color: 'white', textTransform: 'none'}}
              className="yes-button ev-button">
              Yes - Delete
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}
